var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "calciatore-gallery",
      class: "calciatore-gallery--ruolo-" + _vm.calciatore.ID_Ruolo,
    },
    [
      _c("div", { staticClass: "calciatore-gallery-avatar-wrap" }, [
        _c("div", { staticClass: "imgCalciatore without-ms" }, [
          _c("div", { staticClass: "imgContainer imgContainer-ruolo_" }, [
            _c("div", {
              key: _vm.calciatore.nid,
              staticClass: "img",
              style: { backgroundImage: "url(" + _vm.avatarUrl + ")" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _vm.calciatore.ID_Club
          ? _c(
              "div",
              {
                staticClass: "calciatore-gallery-maglia-badge",
                attrs: { "aria-hidden": "true" },
              },
              [
                _c("div", {
                  staticClass: "calciatore-gallery-maglia",
                  style: { backgroundImage: _vm.magliaClub },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calciatore-gallery-info" }, [
        _c("div", { staticClass: "calciatore-gallery-name-row" }, [
          _c(
            "span",
            {
              staticClass: "Ruolo calciatore-gallery-role",
              class: "Ruolo_" + _vm.calciatore.ID_Ruolo,
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.ruolo(_vm.calciatore.ID_Ruolo)) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "calciatore-gallery-name font-hemi-head" },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.calciatore.calciatore) + "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "calciatore-gallery-meta" },
          [
            _vm.mantra && _vm.calciatore.mantra_ids
              ? _c(
                  "span",
                  { staticClass: "d-flex" },
                  _vm._l(_vm.calciatore.mantra_ids, function (mantraId) {
                    return _c(
                      "span",
                      {
                        key: mantraId,
                        staticClass: "ml-1",
                        class: "ruolo-mantra" + mantraId,
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.ruoloMantra(mantraId)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.calciatore.nomeClub))]),
            _vm._v(" "),
            _vm.showQuotazione
              ? _c("quotazione", {
                  attrs: { quotazione: _vm.calciatore.quotazione },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }